import { render, staticRenderFns } from "./projectDiagnose.vue?vue&type=template&id=383e0914&"
import script from "./projectDiagnose.vue?vue&type=script&lang=js&"
export * from "./projectDiagnose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports